import React, { Component } from 'react';
import Header from "../handf/Header";
import Footer from "../handf/Footer";
import PopUp from "../round/PopUp";
import DownloadMap from "./DownloadMap";

import './download.css';
//import {post,} from "../../ajax/tools";


class download extends Component {

    constructor(props){
        super(props);
        this.state = {
            winHeight : '',
            NowNavListZhName:'下载中心',
            NowNavListEnName:'Download Center',
            DownloadNavArr:[
                {
                    ZhName:'下载中心',
                    EnName:'Download Center',
                },
            ],
        };
    }
    componentDidMount=function() {
        const contentHeight = document.body.scrollHeight;//网页正文全文高度
        const winHeight = window.innerHeight;//可视窗口高度，不包括浏览器顶部工具栏
        const ua = navigator.userAgent.toLowerCase();//媒体查询当前设备
        const windows = ua.indexOf('windows');
        const macintosh = ua.indexOf('macintosh');
        const linux = ua.indexOf('linux');
        if (contentHeight < winHeight && windows === -1 && macintosh === -1) {
            this.setState({
                winHeight : winHeight,
            });
        }else if(windows === -1 && macintosh === -1 && linux === -1){
            this.setState({
                winHeight: '',
            });
        } else{
            this.setState({
                winHeight: '',
            });
        }
    };





    //点击左侧菜单
    AccountListClick=(item,index) =>{
        this.setState({
            NowNavListZhName:item.ZhName,
            NowNavListEnName:item.EnName,
        });
    };









    //提示弹窗
    ChildBackTip=(event)=>{
        if(event === 'CrossOut'){
            this.setState({
                PopUp:'',
            });
        }
    };


    render() {
        return (
                <div className={'MainBox'} style={{height:this.state.winHeight,}}>
                    <Header/>
                    <div className={'MainContent'}>
                        <div className={'MainTopBox clearfix'}>
                            <div className={'MainConTitle'}>
                                <div className={'MainConTitZH'}>{this.state.NowNavListZhName}</div>
                                <div className={'MainConTitEN'}>Download&nbsp;&nbsp;Center</div>
                            </div>
                            <div className={'MainConTitBorder'}> </div>
                            <div className={'MainActiveListTitle'}>{this.state.NowNavListEnName}</div>
                        </div>
                        <div className={'ContentMainBox clearfix'} style={{height:window.innerHeight-191,}}>
                            <div className={'MainLeftNavBox'} style={{height:window.innerHeight-191,}}>
                                <ul className={'MainLeftNavListBox'}>
                                    {
                                        this.state.DownloadNavArr.map((item,index) =>
                                            <li className={item.ZhName === this.state.NowNavListZhName ? 'MainLeftNavActiveList' : 'MainLeftNavList'}
                                                key={index}
                                                onClick={() => this.AccountListClick(item,index)}
                                            >
                                                {item.ZhName}
                                            </li>
                                        )
                                    }
                                </ul>
                            </div>
                            <div className={'MainThisNavBox scrollBar'} style={{height:window.innerHeight-191,}}>
                                <div className={'InfoListPositionTitBox'}>
                                    <div className={'InfoListPositionTit'}>
                                        <div className={'InfoListPosition'}>
                                            下载中心&gt;&gt;{this.state.NowNavListZhName}
                                        </div>
                                    </div>
                                </div>
                                <div className={'InfoListBorder'}> </div>
                                {
                                    this.state.NowNavListZhName === '下载中心'&&
                                    <DownloadMap/>
                                }
                            </div>
                        </div>
                        {/*<div className={'PositionBottom'}> </div>*/}
                    </div>
                    <Footer/>
                    {
                        this.state.PopUp === '提示弹窗' &&
                        <PopUp
                            ChildBackClick={this.ChildBackTip.bind(this)}
                            type={'提示'}
                            message={this.state.MessageTip}
                            OutButton={'Yes'}
                        />
                    }
                </div>
        );
    }
}


export default download;
